module.exports = "/next-static/_next/static/images/testimonial_1_author-241af2920a98c4c1b43f7104be71d116.png";